import { render, staticRenderFns } from "./cmpListComp.vue?vue&type=template&id=47273672&scoped=true"
import script from "./cmpListComp.vue?vue&type=script&lang=js"
export * from "./cmpListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47273672",
  null
  
)

export default component.exports